module.exports = __webpack_public_path__ + "img/20180815_152858_224.ba1dbcc7.jpg";